/**
 * worker 定时器
 */
function PiTimer() {
    let tmrRefresh = undefined;
    function todoFn(interval) {
        clearTimeout(tmrRefresh);
        tmrRefresh = setTimeout(function () {
            self.postMessage({ type: "fresh" });
            todoFn(interval); // 递归调用
        }, interval);
    }
    // 在 Web Worker 中监听消息
    self.addEventListener("message", (event) => {
        if (!event.data?.type) {
            return;
        }
        if (event.data.type === "init") {
            const interval = event.data.interval || 60000;
            todoFn(interval);
        }
        else if (event.data.type === "close") {
            clearTimeout(tmrRefresh);
        }
    });
}
/**
 * 定时器,使用场景（类似长时间轮巡），当前业务组件销毁时，需要主动调用关闭函数
 * @param interval 时间间隔，毫秒
 * @param fn 定时器执行的函数
 * @returns 关闭定时器的函数
 */
export function hTimer(fn, interval) {
    // 参数校验,不传、负值、超出最大延迟上限，或者执行函数体为空，则返回
    if (!interval || interval < 0 || interval > Math.pow(2, 31) - 2 || !fn) {
        setTimeout(() => {
            fn && fn();
        }, 0);
        return {};
    }
    let workBlob = new Blob([`(${PiTimer.toString()})()`]);
    const url = URL.createObjectURL(workBlob);
    let worker = new Worker(url);
    // 监听 Web Worker 的消息
    worker.addEventListener("message", (event) => {
        if (event.data.type === "fresh") {
            fn && fn();
        }
    });
    // 在 Web Worker 中创建 settimeout
    worker.postMessage({
        type: "init",
        interval: interval,
    });
    // 定时器关闭函数
    const close = () => {
        if (worker) {
            worker.postMessage({ type: "close" });
            worker.terminate();
        }
        workBlob = null;
        URL.revokeObjectURL(url);
        worker = null;
    };
    return { close: close };
}
